<ngx-spinner
      bdColor="rgba(75, 55, 100, 0.5)"
      size="large"
      color="#fff"
      type="line-scale-pulse-out">
          <span class="chevron left"></span>
          <span class="chevron right"></span>
    </ngx-spinner>

<div class="generic-modal-root">  
    <div class="row-padding">
      <div class="row" style="margin-top: 0;">
        <form
          *ngIf="form"
          [formGroup]="form"
          class="m-form m-form--fit m-form--label-align-right"
          style="width: 100%"
        >
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-6 col-form-label"> Upload .csv File: </label>
            <div class="col-lg-4">
              <div style="display: flex; flex-direction: row;">
                  <input
                    formControlName="csvSectionFile"
                    (change)="addSectionFile($event.target.files[0])"
                    type="file"
                    class="form-control m-input"
                    accept=".csv"
                  />
                  <a *ngIf="form.controls.csvSectionFile.value" 
                    (click)="deleteSectionFile()" 
                    href="#" class="m-menu__link" 
                    style="text-decoration: none; margin-top: 5px; position: relative; left: 8px;"
                    >
                    <i class="m-menu__link-icon flaticon-cancel"></i>
                  </a>
              </div>
              <app-validation-display
                    *ngIf="form.errors?.invalidSections"
					[control]="form"
					errorMessage="You must either specify a range or upload a file, not both."
			    ></app-validation-display>
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <hr style="width: 60%;">
            <label class="col-lg-12" style="text-align: center; margin-bottom: 0;"> OR </label>
            <hr style="width: 60%;">
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-6 col-form-label"> Enter Section Number Range: </label>
            <div class="col-lg-6" style="align-self: center; flex-direction: row;">
                <input
                  style="display: inline-block; width: 30%;"
                  formControlName="startRange"
                  type="number"
                  class="form-control m-input"
                  placeholder="Start"
                />
                <span> - </span>
                <input
                  style="display: inline-block; width: 30%;"
                  formControlName="endRange"
                  type="number"
                  class="form-control m-input"
                  placeholder="End"
                />
                <img src="../../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" style="position: relative;" 
													tooltip="Enter a range of numbers to generate a list of sections where each section name is a number in the range. This includes the start and end of the range.">
                <app-validation-display
                    *ngIf="form.errors?.invalidRange"
					[control]="form"
					errorMessage="Start range must have a value lower than end range"
				></app-validation-display>
                <app-validation-display
                    *ngIf="form.errors?.invalidSections"
					[control]="form"
					errorMessage="You must either specify a range or upload a file, not both."
				></app-validation-display>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-6 col-form-label">
            Show Advanced Range Options:
            </label>
            <div style="padding-top: 7px;" class="col-lg-4">
                <label class="switch">
                <input
                [ngModelOptions]="{standalone: true}"
                [(ngModel)]="showAdvancedRangeOptions"
                type="checkbox"
                />
                <span class="slider round"></span>
                </label>
            </div>
          </div>
          <div [hidden]="!showAdvancedRangeOptions">
            <div class="form-group m-form__group row remove-margin">
                <label class="col-lg-6 col-form-label"> Section Range Prefix: </label>
                <div class="col-lg-4" style="align-self: center; display: flex; flex-direction: row;">
                    <input
                      formControlName="rangePrefix"
                      type="text"
                      class="form-control m-input"
                      placeholder="Example: GA"
                    />
                    <img src="../../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" style="position: relative; top: 8px;" 
													tooltip="For each section in the specified range, the Range Prefix is added to the beginning of the section name.">
                    <app-validation-display
					  [control]="form.controls.rangePrefix"
					  errorMessage="Prefix must be between 0 and 10 characters."
				    ></app-validation-display>
                </div>
            </div>
            <div class="form-group m-form__group row remove-margin">
                <label class="col-lg-6 col-form-label"> Section Range Suffix: </label>
                <div class="col-lg-4" style="align-self: center; display: flex; flex-direction: row;">
                    <input
                      formControlName="rangeSuffix"
                      type="text"
                      class="form-control m-input"
                      placeholder="Example: Mezzanine"
                    />
                    <img src="../../../assets/app/media/img/icons/info-icon.png" class="tooltip-icon" style="position: relative; top: 8px;" 
													tooltip="For each section in the specified range, the Range Suffix is added to the end of the section name.">
                    <app-validation-display
					  [control]="form.controls.rangeSuffix"
					  errorMessage="Suffix must be between 0 and 10 characters."
				    ></app-validation-display>
                </div>
            </div>
          </div>
  
          <div style="display: flex; justify-content: center; margin-top: 30px;">
            <button
              [disabled]="!csvSectionFile && !form.controls.startRange.value && !form.controls.endRange.value"
              (click)="submit()"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Confirm
            </button>
            <button
              (click)="close()"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Close
            </button>
          </div>
          <div *ngIf="hasValidationErrors" style="text-align: center;">
            <span style="color:red">Please complete the required fields or fix the errors.</span>
          </div>
        </form>
      </div>
    </div>
  </div>